import { pairingConfig, type PairingEnv } from './pairingConfig.js';

/**
 * Dove l'app chiede se ne esiste una versione più nuova di sé.
 *
 * ## È l'autenticatore, cioè **lo stesso host dell'accoppiamento**
 *
 * Non un indirizzo in più da configurare: è quello di `pairingConfig`, con `/v1/apps` dietro. E non
 * è una comodità — è l'unico host che l'app possa interrogare. Un apparecchio appena installato non
 * sa a quale gateway appartiene, perché scoprirlo è tutto il senso dell'accoppiamento; e l'indirizzo
 * dell'accoppiamento è l'unico compilato dentro il pacchetto.
 *
 * ## Perché non il gestore delle licenze, e perché non il gateway
 *
 * Il **gestore delle licenze** firma e versiona i rilasci, ma gira in locale su una macchina di
 * lavoro: non è un host pubblico e non lo diventerà. Era la prima stesura di questo file, ed era
 * sbagliata.
 *
 * Il **gateway** è un binario per cliente che non sa niente del registro, e insegnarglielo vorrebbe
 * dire far transitare mezzo giga di pacchetto da lui per ogni televisore — la stessa banda che un
 * deposito comune esiste per non far pagare due volte.
 *
 * ## Cosa protegge l'aggiornamento, e non è questo indirizzo
 *
 * L'indice non è firmato: un host dirottato potrebbe annunciare una versione che non esiste. Quello
 * che non può fare è **sostituire l'app**, perché Android rifiuta un aggiornamento firmato con una
 * chiave diversa dalla nostra — e la nostra sta sulla macchina dell'autenticatore. Il peggio
 * ottenibile è un avviso che propone un file che non si installa.
 */

/** Il percorso dei pacchetti sull'autenticatore. La versione nel percorso c'è dal primo giorno. */
export const APPS_PATH = '/v1/apps';

/**
 * L'indirizzo effettivo di questa compilazione, senza barra finale.
 *
 * In sviluppo `pairingConfig` risponde la stringa vuota — il server di sviluppo gira le richieste
 * verso il servizio vero, così per il browser è tutto la stessa origine e il CORS non entra in
 * gioco. Qui quella stringa vuota resta tale: il risultato è `/v1/apps`, cioè casa propria.
 */
export function releaseBaseUrl(env: PairingEnv = import.meta.env): string {
  return `${pairingConfig(env).baseUrl.replace(/\/+$/, '')}${APPS_PATH}`;
}
